module.exports = __webpack_public_path__ + "static/media/Medcare Orthopaedics & Spine Hospital.3377ea81.jpg";